import React from "react";

class EarnPointsForm extends React.Component {

  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  onSubmit(e){
    e.preventDefault();
    this.props.changeView('redeem_points');
  }

  render() {
    return (
      <div className="main-container-loyalty">
        <h3 className="base-heading">SET YOUR LOYALTY PROGRAM</h3>
        <p className="sub-heading">
          Choose how your customers will earn points
        </p>

        <div className="loyalty-menu-options-child">
          <img
            className="loyalty-menu-options-child-image"
            src="/amountSpent.svg"
          />
          <p className="loyalty-menu-heading">Earn points by Amount</p>
        </div>

        <div className="loyalty-menu-form">
          <form onSubmit={this.onSubmit}>
            <div className="loyalty-menu-form-field">
              <p>How many points will the customer earn</p>
              <div className="loyalty-menu-form-custom-div">
                Customer will be awarded{" "}
                <input className="custom-input" type="number" placeholder="0" />Points
                for every Rs.{" "}
                <input className="custom-input" type="number" placeholder="0" />Spent
              </div>
            </div>

            <div className="loyalty-menu-form-field">
              <p>Minimum spend required for earning points</p>
              <div className="loyalty-menu-form-custom-div">
                Rs.
                <input type="number" className="loyalty-form-input-field" placeholder="0" />
              </div>
            </div>

            <div className="loyalty-menu-form-button-container">
                <button type="submit" className="loyalty-menu-form-button">Next</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EarnPointsForm;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/EarnPointsForm.js